module.exports = __webpack_public_path__ + "img/77d5f60.jpg";